import axios from "axios";

export const getImpresionPresupuesto = async (idPresupuesto) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/impresion-presupuesto/${idPresupuesto}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ImpresionPresupuesto:", error);
    throw error;
  }
};
